import React, { useEffect, useState } from "react";
import TextEditor from "../Common/textEditor";
import Drawer from 'react-modern-drawer';
import GenerationAllServices from "./generationAllServices";
import CurrentJobs from "components/User Profile/CurrentJobs";
import EmailTemplate from "./EmailTemplate";
import DeleteDialogueBox from "components/Common/deleteDialogue";

export default function EmailStatement(param: any) {

    const [saveTemplate, setsaveTemplate] = useState(0)
    const [clientCCs, setClientCCs] = useState("")
    const [emailTempList, initEmailTemplist] = useState<any>([]);
    const [getClientDetails, setClientDetails] = useState<any>([]);
    let [openEmailTemplate, setopenEmailTemplate] = useState(false)
    let [approvalCheck, setapprovalCheck] = useState(false)


    console.log(param)
    useEffect(() => {
        GenerationAllServices.emailTemplateListing().then((res: any) => {
            initEmailTemplist(res[0])
            emailTempList.isLive = false
            initEmailTemplist(emailTempList)
        })

        GenerationAllServices.getClientDetails().then((res: any) => { setClientDetails(res[0]) })

        approvalListCheck();
    }, []);

    const EmailStatementClose = () => { param.EmailStatementClose(); }


    const approvalListCheck = () => {
        var contractList = []
        if (param?.emailOptionData?.contract) {
            contractList.push(param?.emailOptionData?.contract)
        }
        var payload = {
            isAll: 0,
            listContacts: [],
            listContracts: contractList,
            listPeriods: ["20240331"],
            "periodFrom": param?.emailOptionData?.periodFrom,
            "periodTo": param?.emailOptionData?.periodTo,
            projectId: 9,
            type: "approvalCheck"
        }

        GenerationAllServices.approvalListCheck(payload).then((respond: any) => {
            approvalCheck = respond
            setapprovalCheck(approvalCheck)
        })
    }

    const saveEmailUserTemplate = () => {
        var payload = {
            attachment: emailTempList?.attachment ?? "",
            createdBy: emailTempList?.createdBy ?? "",
            dateCreated: emailTempList?.dateCreated ?? "",
            dateModified: emailTempList?.dateModified ?? "",
            id: saveTemplate == 1 && emailTempList?.id ? emailTempList?.id : 0,
            message: emailTempList?.message ?? "",
            modifiedBy: emailTempList?.modifiedBy ?? 0,
            signature: emailTempList?.signature ?? "",
            subject: emailTempList?.subject ?? "",
            totalRows: emailTempList?.totalRows ?? 0,
            type: emailTempList?.type ?? "",
            typeId: emailTempList?.typeId ?? 0,
            userId: emailTempList?.userId ?? 0
        };

        console.log(payload);
        GenerationAllServices.saveEmailUserTemplate(payload);
        console.log(emailTempList)
    }

    const SendEmailQueueStatements = () => {
        console.log(param)
        console.log(emailTempList)

        var contractList = []
        if (param?.emailOptionData?.contract) {
            contractList.push(param?.emailOptionData?.contract)
        }

        if (saveTemplate > 0) {
            saveEmailUserTemplate();
        }

        var email_payload = {
            "attachment": emailTempList?.attachment,
            "clientCC": "",
            "clientCCs": false,
            "clientFtp": false,
            "closedPeriod": false,
            "configcc": "",
            "contactNoEmail": 2,
            "contactType": "Royalty",
            "emailCCs": false,
            "emailMessage": emailTempList?.message,
            "emailSignature": emailTempList?.signature,
            "emailSubject": emailTempList?.subject,
            "format": "zip",
            "hasEmail": 1,
            "isAll": 0,
            "isLive": emailTempList?.isLive ?? false,
            "listContracts": contractList,
            "loggedUserEmail": JSON.parse(sessionStorage.getItem('loggedUserRight') || '{}')?.email,
            "method": "emailqueue",
            "periodFrom": param?.emailOptionData?.periodFrom,
            "periodTo": param?.emailOptionData?.periodTo,
            "projectCode": "",
            "projectId": "",
            "reportType": "",
            "resume": 0,
            "searchFor": ""
        }

        GenerationAllServices.emailStatment(email_payload)

        console.log(email_payload)
    }
    const EmailTemplateClose = (e: any) => {
        openEmailTemplate = false
        setopenEmailTemplate(openEmailTemplate)

        console.log(e)
        emailTempList.subject = e.subject
        emailTempList.message = e.message
        emailTempList.attachment = e.attachment
        emailTempList.signature = e.signature

        initEmailTemplist({ ...emailTempList })
        console.log(emailTempList)
    }


    let [emailStatementStatus, setEmailStatementStatus] = useState(false);
    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(emailStatementStatus)
        if (e == 1) {
            SendEmailQueueStatements();
        }
        //e==2 NO
        emailStatementStatus = false;
        setEmailStatementStatus(emailStatementStatus)
    }

    return (
        <>
            <Drawer open={param.openEmailStatement} onClose={() => EmailStatementClose()} direction={"right"} className='react-drawer allowHscroll allowVscroll'>

                <div className="box w-58 pull-right landing forceScroll">

                    <div className="ws-12 allowHscroll allowVscroll">

                        <div className="ws-12 box-header-main">
                            <h2 className="ws-6"><strong >Email Options -</strong> <i >M00007_TEST</i></h2>
                            <div className="ws-6" style={{ marginTop: "-7px;" }}>
                                <CurrentJobs type="calculation" />
                            </div>
                        </div>

                        <button className="icon-btn edit pull-right mt width150 height35" onClick={() => setopenEmailTemplate(true)}>Email Templates</button>

                        <div className="box-content">
                            <div className="form-format ws-12 mtl box pm">
                                <label className="control-label text-bold ws-12">Subject*</label>
                                <div className="label-entries ws-12">
                                    <input type="text" name="subject" value={emailTempList.subject} onChange={(e: any) => initEmailTemplist({ ...emailTempList, ...{ subject: e.target.value } })} placeholder="Enter Subject" />
                                </div>
                            </div>

                            <div className="form-format ws-12 mtl box pm">
                                <label className="control-label text-bold ws-12">Message*</label>
                                <div className="label-entries ws-12">
                                    <TextEditor onchangeEditor={(e: any) => initEmailTemplist({ ...emailTempList, ...{ message: e } })} textvalue={emailTempList.message} />
                                </div>
                            </div>

                            <div className="form-format ws-12 mtl box pm">
                                <label className="control-label text-bold ws-12">Attachment Limit Exceeded*</label>
                                <div className="label-entries ws-12">
                                    <TextEditor onchangeEditor={(e: any) => initEmailTemplist({ ...emailTempList, ...{ attachment: e } })} textvalue={emailTempList.attachment} />
                                </div>
                            </div>

                            <div className="form-format ws-12 mtl box pm">
                                <label className="control-label text-bold ws-12">Signature</label>
                                <div className="label-entries ws-12">
                                    <TextEditor onchangeEditor={(e: any) => initEmailTemplist({ ...emailTempList, ...{ signature: e } })} textvalue={emailTempList?.signature ?? ""} />
                                </div>
                            </div>

                            <div className="form-format ws-12 mtl box pm">
                                <label>Template option for Subject, Message, and Signature</label>
                                <label className="ws-12 mll pl">
                                    <div className="ws-12">
                                        <input type="radio" name="saveTemplate" value={saveTemplate} onClick={() => setsaveTemplate(0)} checked={saveTemplate == 0} /> Don't save
                                    </div>
                                    <div className="ws-12">
                                        <input type="radio" name="saveTemplate" value={saveTemplate} onClick={() => setsaveTemplate(1)} checked={saveTemplate == 1} /> Update template
                                    </div>
                                    <div className="ws-12">
                                        <input type="radio" name="saveTemplate" value={saveTemplate} onClick={() => setsaveTemplate(2)} checked={saveTemplate == 2} /> Save as new template
                                    </div>
                                </label>
                            </div>

                            <div className="form-format ws-12 mtl box pm">
                                <label>Send a copy to:</label>
                                <label className="ws-12 mll pl">
                                    <div className="ws-12">
                                        <input type="radio" name="clientCC" checked={clientCCs == "ccEmailListR"} onClick={() => setClientCCs("ccEmailListR")} /> {getClientDetails?.royaltyCc}</div>
                                    <div className="ws-12">
                                        <input type="radio" name="clientCC" checked={clientCCs == "ccEmailListM"} onClick={() => setClientCCs("ccEmailListM")} /> {getClientDetails?.mechanicalCc}</div>
                                    <div className="ws-12">
                                        <input type="radio" name="clientCC" checked={clientCCs == "ccEmailListP"} onClick={() => setClientCCs("ccEmailListP")} /> {getClientDetails?.publisherCc}</div>
                                    <div className="ws-12">
                                        <input type="radio" name="clientCC" checked={clientCCs == ""} />No one
                                    </div>
                                </label>
                            </div>

                            <div className="form-format ws-12 mtl box pm">
                                <label className="ws-12">
                                    <input type="checkbox" name="clientFtp" checked={emailTempList?.clientFtp} onChange={(e: any) => initEmailTemplist({ ...emailTempList, ...{ clientFtp: !emailTempList?.clientFtp } })} />  Send a copy to my ftp address
                                </label>

                                <label className="ws-12 mt">
                                    Draft (send a copy to me)
                                    <input type="radio" checked={emailTempList?.isLive == false} onChange={(e: any) => initEmailTemplist({ ...emailTempList, ...{ isLive: false } })} name="isLive" />
                                </label>

                                <label className="ws-12 mt">
                                    Live
                                    <input type="radio" checked={emailTempList?.isLive == true} onChange={(e: any) => initEmailTemplist({ ...emailTempList, ...{ isLive: true } })} name="isLive" />
                                </label>

                            </div>

                            {!approvalCheck && <div className="ptl ws-12">
                                <div className="label-danger ws-12 text-center">
                                    The selected list of statements contains some unapproved. Please ensure all statements are approved before emailing live.
                                </div>
                            </div>}

                        </div>

                        <div className="ws-12 pm">
                            <button onClick={() => setEmailStatementStatus(true)} className="icon-btn info width100 height35 pull-right"> Email </button>
                            <button onClick={EmailStatementClose} className="icon-btn delete width100 height35 pull-right" > Close </button>
                        </div>
                    </div>

                    {(() => {

                        if (openEmailTemplate) {
                            return <EmailTemplate openEmailTemplate={openEmailTemplate} EmailTemplateClose={EmailTemplateClose} />;
                        }

                        if (emailStatementStatus) {
                            return <DeleteDialogueBox param={emailStatementStatus} message={"to send (1) of contracts Y/N"} onChange={deleteConfirmation} />
                        }

                    })()}

                </div>

            </Drawer>

        </>
    )
}